const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trading calculator</h1>
        <p>
          Calculate pips, margin, spread, commission and more with The Pips
          trading calculator. Our handy tool can help you simplify complex
          calculations for your trading positions.
        </p>
      </div>
      <br></br><br></br>
    </div>
  );
};

export default TopicOne;
